<template>

	<div class="mt-4 mb-4 ss-membership">
		<transition name="list">
			<div class="row" v-show="stepsWatch.membership.intro === true">
				<div class="col-md-4 offset-md-4">
					<div class="intro-wrapper">
						<div class="ss-title" v-html="$parseHtml($store.state.steps.two.title)"></div>

						<div class="checks">
							<div class="check" v-for="(check, i) in $store.state.steps.two.intro" :key="i">
								<i class="fa fa-check text-primary mr-3"></i>
								<p v-html="$parseHtml(check)"></p>
							</div>							
						</div>

						<button class="mt-4 btn btn-lg btn-block btn-primary" @click.prevent="$store.commit('setStep', { step: 'membership', prop: 'intro', value: false })">{{$store.state.steps.two.introButtonText}}</button>
						<!--<router-link :to="{ name: 'select-studio' }" tag="a" class="text-primary text-center mt-3 d-block">Go Back</router-link>-->
					</div>

				</div>
			</div>
		</transition>
		<transition name="list">
			<div class="row ss-plans" v-show="stepsWatch.membership.intro === false">

				<div class="col-md-6 offset-md-3 mb-2">

					<div>
						<div class="ss-lead" v-if="$store.state.steps.two.plansLead" v-html="$parseHtml($store.state.steps.two.plansLead)"></div>
						<div v-else>
							<h4 class="mb-1">Choose the right plan for you!</h4>
							<h6 class="mb-0">Downgrade or upgrade at any time.</h6>
						</div>
					</div>

					<div class="table-wrapper">
						<table class="table">
							<thead>
								<tr>
									<th class="d-none d-xl-table-cell">
										<div></div>
									</th>
									
									<th v-for="plan in signupPlans" :key="plan.id" class="text-center">
										<div @click="planId = plan.id" class="plan-selector" :class="{'active': planId === plan.id}" v-html="$parseHtml(plan.title)"></div>
									</th>
								</tr>
							</thead>
							<tbody>
								<template v-for="(row, i) in plans.table.rows">

									<tr class="d-xl-none" :key="i + '_'">
										<td style="border-bottom: 0; padding-bottom: 0" :colspan="signupPlans.length" class="text-center" v-html="$parseHtml(replaceTokens(row[0]))"></td>
									</tr>
									<tr :key="i">
										<td class="d-none d-xl-table-cell"><div v-html="$parseHtml(replaceTokens(row[0]))"></div></td>

										<td v-for="(item, x) in row.slice(1)" :key="x" class="text-center" :class="{'active': determineActive(x)}">
											<div v-html="item"></div>
										</td>
									</tr>
								</template>


							</tbody>

						</table>
					</div>


					<div class="text-center">
						<router-link :to="{name: 'profile'}" class="btn btn-primary btn-lg" style="width: 300px;">{{$store.state.steps.two.nextButtonText}}</router-link>
						<a style="cursor: pointer" @click="stepsWatch.membership.intro = true" class="text-primary mt-2 d-block">Go Back</a>
					</div>







				</div>

				

			</div>
		</transition>

	</div>

</template>

<script>

	
	import { mapGetters } from "vuex";


	

	
	export default {
		name: "select-membership",
		components: {
			
		},
		data() {
			return {
				
			}
		},

		created() {
			this.referredBy = this.$route.params.referredBy;
			//if (!this.selectedStudio) {
			//	this.$router.push({ name: "select-studio" });
			//} else {
			//	if (!this.planId) {
			//		this.planId = this.plans.preSelect;
			//	}				
			//}

			
			if (!this.planId) {
				this.planId = this.plans.preSelect;							
			}
		},

		computed: {
			...mapGetters({
				selectedStudio: "selectedStudio",
				selectedPlan: "selectedPlan",
				locations: "locations",
				plans: "plans",
				stepsWatch: "stepsWatch"
			}),

			signupPlans() {
				return this.plans.plans.filter(p => p.planType === 'Mem');
      },

			referredBy: {
				get() {
					return this.$store.state.referredBy;
				},
				set(val) {
					this.$store.commit("setReferral", val);
				}
			},

			trialEnds() {
				var date = new Date();
				date.setMonth(date.getMonth() + 1)
				var dd = String(date.getDate()).padStart(2, '0');
				var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
				var yyyy = date.getFullYear();
				date = mm + '/' + dd + '/' + yyyy;
				return date;
			},

			planId: {
				get() {
					return this.$store.state.planId;
				},
				set(val) {
					this.$store.commit("setPlan", val);
				}
			}
		},

		methods: {

			parseHtml(check) {
				//console.log(check)
				const regex = /{{[a-zA-Z0-9_ ]+:[a-zA-Z0-9_ ]+}}/g;
				let test = check.match(regex);
				if (test && test.length > 0) {
					_.each(test, t => {
						
						// remove curly
						let x = t.replace("{{", "").replace("}}", "");
						let parts = x.split(":");
						let modal = parts[0];
						let text = parts[1];
						check = check.replace(t, '<a class="text-primary" data-modal="' + modal + '" onclick="loadModal(this)">' + text + '</a>');
					})
				}
				
		
				return check;
			},

			selectPlan(id) {
				this.planId = id;
				this.$router.push({ name: 'profile' });
			},

			replaceTokens(row) {
				return row.replace("{{trialenddate}}", this.trialEnds);
			},

			determineActive(idx) {
				var activeIdx = _.findIndex(this.signupPlans, { 'id': this.planId });
				
				return activeIdx === idx;
			}
		},

		watch: {

			//:to="{ name: 'select-studio' }" tag="a" class="text-primary mt-4 d-block">Go Back</a-link>
			"stepsWatch.membership.intro": function (val) {
				window.scroll(0, 0);
			},

			planId: function (val) {
				
			}
		}
	}
</script>

<style scoped lang="scss">

	.table th, .table td {
    border-bottom: 1px solid #dee2e6;
		border-top: 0;
	}

	
	
	table.table tbody tr td:not(:first-child) {
		opacity: .5;
	}
	table.table tbody tr td.active {
		opacity: 1;
		color: #cc6600;
	}
	table.table thead tr th {
		border-top: 0;
	}

	.plan-selector {
		background: #cc6600;
		color: white;
		width: 80px;
		height: 80px;
		display: flex;
		flex-direction:column;
		justify-content: center;
		align-items: center;
		font-size: 12px;
		line-height: 18px;
		opacity: .5;
		cursor: pointer;
		margin:auto;
		transition: all 0.3s;
	}

	.plan-selector.active {
		opacity: 1;
		position: relative;
	}

	.plan-selector.active::after {
    content: '';
    display: block;
    border: 0 solid transparent;
    border-top-color: #cc6600;
    position: absolute;
    top: 100%;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
		border-width: 10px;
    border-bottom-width: 0;
	}


	.list-enter,
	.list-leave-to {
		visibility: hidden;
		height: 0;
		margin: 0;
		padding: 0;
		opacity: 0;
	}

	.list-enter-active,
	.list-leave-active {
		transition: all 0.3s;
	}

	.intro-wrapper {
		max-width: 300px;
		margin: auto;
	}
	.checks {
		
		max-width: 300px;
		margin: auto;/*
		position: relative;
		left: 5px;*/
		display: flex;
		flex-direction: column;
		
	}

	.check {
		position: relative;
		display: flex;
		align-items: flex-start;
		font-size: 18px;
	}
	.check p {
		font-size: 16px;
		margin-bottom: 15px;
		color: #333;
	}

		.check i {
			position: relative;
			right: -5px;
			top: 5px;			
		}
</style>